import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ExpressionOutput_Boolean, ExpressionType_ResolutionFunction } from '@app/hcs-shared/expression';
import { ModuleFE_PathwayState } from '../../_entity/pathway-state/index.js';
export const getEmptyResolutionFunction = (transition) => {
    const sourceState = ModuleFE_PathwayState.cache.unique(transition.sourceId);
    if (!sourceState)
        throw new MUSTNeverHappenException(`state with id ${transition.sourceId} not found`);
    const targetState = ModuleFE_PathwayState.cache.unique(transition.targetId);
    if (!targetState)
        throw new MUSTNeverHappenException(`state with id ${transition.targetId} not found`);
    return Object.freeze({
        terms: [],
        expression: 'T1',
        isEvidenceBased: false,
        label: `${sourceState.name} => ${transition.label ? transition.label : targetState.name}`,
        outputType: ExpressionOutput_Boolean,
        expressionType: ExpressionType_ResolutionFunction.dbKey,
        tagGroups: []
    });
};
//# sourceMappingURL=const.js.map